import { Component, input, type InputSignal } from '@angular/core';

import { PaceNotificationPreviewInterface } from './pace-notification-preview.interface';
import { RouterLink } from '@angular/router';
import { PaceLink } from '../utils/link.interface';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'pace-notification-preview',
    imports: [RouterLink, FontAwesomeModule],
    templateUrl: './pace-notification-preview.component.html',
    styleUrls: ['./pace-notification-preview.component.scss'],
})
export class PaceNotificationPreviewComponent {
    public readonly notificationType = input.required<string>();
    public readonly notification = input.required<PaceNotificationPreviewInterface>();
    public readonly extraLinks: InputSignal<PaceLink[]> = input<PaceLink[]>([]);

    public onLinkClick(link: PaceLink): void {
        if (link.action) {
            link.action();
        }
    }
}
